import { h } from '@stencil/core';
import { EQdsButtonImportance, EQdsButtonSize } from '@pes-ui/utils';
export class ViewMoreLink {
  constructor() {
    this.handleClick = () => this.didToggleViewMore.emit(!this.isExpanded);
    this.isExpanded = undefined;
    this.viewMoreLabel = undefined;
    this.viewLessLabel = undefined;
    this.size = undefined;
    this.importance = undefined;
  }
  render() {
    const text = this.isExpanded ? this.viewLessLabel : this.viewMoreLabel;
    return (h("qds-button", { class: "view-more-link", onClick: this.handleClick, size: this.size || EQdsButtonSize.STANDARD, importance: this.importance || EQdsButtonImportance.SUBDUED, action: this.isExpanded ? 'dropdown-close' : 'dropdown', text: text }));
  }
  static get is() { return "pes-view-more-link"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "isExpanded": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Is expanded mode or not."
        },
        "attribute": "is-expanded",
        "reflect": false
      },
      "viewMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "\"View more\" label."
        },
        "attribute": "view-more-label",
        "reflect": false
      },
      "viewLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "\"View less\" label."
        },
        "attribute": "view-less-label",
        "reflect": false
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "\"size\" attribute for the button."
        },
        "attribute": "size",
        "reflect": false
      },
      "importance": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "\"importance\" attribute for the button."
        },
        "attribute": "importance",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "didToggleViewMore",
        "name": "didToggleViewMore",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        }
      }];
  }
}
